// Utility functions
export const encodeUri = (value: string | null | undefined): string | null => {
  if (!value) return null;
  return encodeURIComponent(value);
};

export const ellipseIfOver = (string: string, limit: number): string => {
  if (string.length > limit) {
    return `${string.slice(0, limit - 3)}...`;
  }
  return string;
};

export const cleanVar = (value: string | null | undefined): string => {
  if (!value) return '';
  return value.replace(/[\/,"'#\t\n]/g, '');
};

export const capitalize = (string: string, replaceAll: boolean = true): string => {
  if (!string) return '';
  const words = string.replace(/[_\-]/g, ' ').replace(/,/g, ' ').split(' ').filter(Boolean);
  const capitalized = words.map(word => {
    if (!word) return '';
    const firstChar = word[0].toUpperCase();
    const rest = word.slice(1).toLowerCase();
    return `${firstChar}${rest}`;
  });
  return replaceAll ? capitalized.join('') : capitalized.join(' ');
};
